<div class="educare-checkbox">
  <div *ngFor="let item of items">
    @if (multiple) {
      <mat-checkbox
        [disabled]="disabled"
        [checked]="Array.isArray(selected) && selected.includes(item.id)"
        (change)="onChange($event, item.id)"
        >{{ item.label }}</mat-checkbox
      >
    } @else {
      <mat-checkbox [disabled]="disabled" [checked]="selected === item.id" (change)="onChange($event, item.id)">{{
        item.label
      }}</mat-checkbox>
    }
  </div>
</div>
